import React from "react";
import { DuplicateProductFormContext } from "./context";

export const useDuplicateProductFormProvider = () => {
  const context = React.useContext(DuplicateProductFormContext);
  return context;
};
